var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-phone-number-input',{attrs:{"fetch-country":_vm.fetchCountry,"no-use-browser-locale":_vm.noUseBrowserLocale},on:{"update":_vm.setPhone},model:{value:(_vm.phoneInput),callback:function ($$v) {_vm.phoneInput=$$v},expression:"phoneInput"}})
}
var staticRenderFns = []

export { render, staticRenderFns }